module.exports = __webpack_public_path__ + "img/opiniooon-logo-dark.6456c645.svg";